export const content = {
  es: {
    documentTitle: 'CIVILI. La capa que falta',
    documentDescription:
      'ATRIO contesta WhatsApp con el estado real de tu sistema y pasa a una persona lo que no es rutina. CANTERA te dice a quién escribirle y por qué. CIVILI construye la capa que le falta a tu operación.',
    'nav.skip': 'Saltar al contenido',
    'nav.brand': 'CIVILI, volver al inicio',
    'nav.label': 'Navegación principal',
    'nav.products': 'Productos',
    'nav.layers': 'A la medida',
    'nav.method': 'Método',
    'nav.cta': 'Hablemos',
    'nav.pause': 'Pausar el movimiento',
    'nav.play': 'Reanudar el movimiento',

    'hero.title1': 'Tu equipo',
    'hero.title2': 'no debería ser',
    'hero.title3': 'la capa de integración.',
    'hero.kicker': 'El mismo pedido. Cuatro versiones. Ninguna manda.',
    'hero.primary': 'Muéstranos dónde se rompe',
    'hero.secondary': 'Ver cómo funciona',

    'ticker.i1': 'WhatsApp · pedido #742 · “ya casi sale” · 14:02',
    'ticker.i2': 'Hoja de cálculo · fila 118 · despachado · 11:30',
    'ticker.i3': 'ERP · OV-000742 · pendiente de pago · 09:15',
    'ticker.i4': 'Memoria · “el de Marta” · quedó en revisar algo · ayer',
    'ticker.alt':
      'Escena conceptual: el mismo pedido aparece en WhatsApp, en una hoja de cálculo, en el ERP y en la memoria de alguien, con un estado distinto en cada uno. No es un caso de cliente.',

    'demo.example': 'Ejemplo',
    'demo.limitLabel': 'Hasta dónde llega',

    'atrio.label': 'Producto 01 · En vivo',
    'atrio.name': 'ATRIO',
    'atrio.line': 'Contesta lo que se repite. Te pasa lo que no.',
    'atrio.limit': 'No decide por ti. Cuando deja de ser rutina, se aparta.',
    'atrio.channel': 'WhatsApp',
    'atrio.who1': 'Cliente',
    'atrio.who2': 'ATRIO',
    'atrio.msg1': '¿Ya salió el pedido 742?',
    'atrio.msg2': 'Sí, salió hoy 11:30. Guía TX-4471, llega mañana.',
    'atrio.note2': 'leído de tu sistema, no de un guion',
    'atrio.msg3': 'Llevo tres días esperando. Esto es un desastre.',
    'atrio.handoff': 'Reclamo. No lo contesta: se lo pasa a una persona.',
    'atrio.transcript':
      'Conversación de ejemplo. El cliente pregunta si ya salió el pedido 742. ATRIO responde con el dato leído del sistema: salió hoy a las 11:30, con la guía TX-4471, y llega mañana. Después el cliente escribe que lleva tres días esperando y que esto es un desastre. ATRIO no contesta ese mensaje: lo reconoce como reclamo y se lo pasa a una persona. No es un caso de cliente.',

    'cantera.label': 'Producto 02 · Construido',
    'cantera.name': 'CANTERA',
    'cantera.line': 'Te dice a quién escribirle y por qué.',
    'cantera.limit': 'No compra listas ni promete respuestas.',
    'cantera.target': 'Empresa · transporte de carga',
    'cantera.found': 'Lo que encontró en su sitio',
    'cantera.e1': 'Botón de WhatsApp en cada página',
    'cantera.e2': 'Tres sedes publicadas',
    'cantera.e3': 'Responde reseñas a mano',
    'cantera.verdict': 'Califica',
    'cantera.reason': 'atiende por chat, y lo hace a pulso',
    'cantera.draftLabel': 'Borrador',
    'cantera.draft': '“Vi que atienden por WhatsApp desde las tres sedes…”',
    'cantera.gate': 'No sale hasta que lo apruebas.',
    'cantera.transcript':
      'Escena de ejemplo. CANTERA revisa el sitio público de una empresa de transporte de carga y anota lo que encuentra: botón de WhatsApp en cada página, tres sedes publicadas y reseñas respondidas a mano. Con eso la califica y deja escrita la razón: atiende por chat y lo hace a pulso. Escribe un borrador de correo y ahí se detiene, porque no sale hasta que una persona lo aprueba. No es un caso de cliente.',

    'layers.label': 'A la medida',
    'layers.title': 'Lo demás se construye. Cada capa dice hasta dónde llega.',
    'layers.limit': 'El límite',
    'layers.l1name': 'Una sola versión de la verdad',
    'layers.l1body': 'Conectamos lo que ya usas y definimos cuál versión manda.',
    'layers.l1limit': 'Si dos áreas no acuerdan qué es “listo”, ninguna integración lo decide.',
    'layers.l2name': 'Automatizar sin perder el control',
    'layers.l2body': 'Mueve datos y valida reglas solo. Ante lo raro, se detiene.',
    'layers.l2limit': 'Automatizar un proceso roto hace que el error llegue más rápido.',
    'layers.l3name': 'La herramienta que sí usan',
    'layers.l3body': 'La interfaz o el CRM montado sobre tu proceso real.',
    'layers.l3limit': 'Si un producto estándar lo resuelve mejor, úsalo.',
    'layers.l4name': 'Conocimiento que no se va',
    'layers.l4body': 'Lo que vive en chats y cabezas queda escrito y consultable.',
    'layers.l4limit': 'Si nadie lo escribió nunca, ningún sistema lo recuerda por ti.',

    'method.label': 'Cómo trabajamos',
    'method.title': 'No hay factura hasta que apruebas qué se construye.',
    'method.free': 'Sin costo',
    'method.paid': 'Con costo',
    'method.p1title': 'Diagnóstico',
    'method.p1body': 'Dónde vive el estado y qué lo rompe.',
    'method.p2title': 'Blueprint y MVP',
    'method.p2body': 'El alcance real y algo que puedes probar.',
    'method.p3title': 'Construcción',
    'method.p3body': 'Si toma más horas, el precio no sube.',
    'method.p4title': 'Transferencia',
    'method.p4body': 'Tu entorno, tu documentación, tu equipo.',
    'method.after': 'Mantenimiento y mejora se cotizan aparte. La recurrencia nace de operar, no de encerrarte.',

    'contact.title1': 'Cuéntanos dónde',
    'contact.title2': 'se pierde el estado.',
    'contact.terms': 'Sin costo · Conversación de negocio · Si no conviene construir, te lo decimos',
    'contact.direct': 'O escríbenos directamente',

    'form.review': 'Canal operativo',
    'form.title': 'Prepara la conversación',
    'form.optional': 'opcional',
    'form.role': 'Cargo',
    'form.phone': 'WhatsApp o teléfono',
    'form.phoneHint': 'Opcional. Acelera el primer contacto.',
    'form.team': 'Personas que tocan esa operación',
    'form.select': 'Selecciona',
    'form.cost': 'Qué te está costando más hoy',
    'form.cost1': 'Todavía no sé cuál es el problema de fondo',
    'form.cost2': 'Sistemas que dicen cosas distintas',
    'form.cost3': 'El conocimiento vive en pocas cabezas',
    'form.cost4': 'El pipeline no es observable',
    'form.cost5': 'Responder a tiempo depende de quién esté disponible',
    'form.cost6': 'Una tarea puntual se repite demasiado',
    'form.notice': 'Tu solicitud llega al canal operativo de CIVILI.',
    'form.name': 'Nombre y apellido',
    'form.company': 'Empresa',
    'form.email': 'Correo corporativo',
    'form.context': 'Descríbelo en tus palabras',
    'form.contextHint': 'Qué pasa hoy, quién lo hace y cada cuánto. Dos o tres frases bastan.',
    'form.consent': 'Autorizo a CIVILI a contactarme sobre esta solicitud.',
    'form.submit': 'Enviar solicitud',
    'form.submitting': 'Enviando…',
    'form.cursorSend': 'Enviar',
    'form.invalid': 'Revisa los campos señalados antes de continuar.',
    'form.success': 'Solicitud recibida. Conservaremos este identificador como referencia.',
    'form.successTitle': 'La conversación ya empezó.',
    'form.reset': 'Enviar otra solicitud',
    'form.networkError':
      'No pudimos enviar la solicitud. Tus respuestas siguen aquí; intenta de nuevo o escribe a accounts@civili.systems.',
    'form.storageError':
      'El canal no pudo registrar la solicitud. Tus respuestas siguen aquí; intenta de nuevo o escribe a accounts@civili.systems.',
    'form.rejectedError':
      'La solicitud no fue aceptada. Revisa los datos o escribe a accounts@civili.systems.',
    'form.privacy': 'Usamos estos datos únicamente para contactarte sobre esta solicitud.',
    'form.privacyLink': 'Política de tratamiento de datos',
    'form.channelNote': 'Se usa únicamente para responder a esta conversación.',

    'footer.position': 'Construimos cómo debe funcionar.',
    'footer.evidence': 'CIVILI no presenta simulaciones como resultados de clientes.',
    'footer.company': 'CIVILI PROJECT SOLUTIONS S.A.S · Colombia',
    'footer.legal': 'Documentos legales',
    'footer.privacy': 'Política de tratamiento de datos',
    'footer.deletion': 'Eliminación de datos',
    'footer.social': 'Redes sociales',
    'footer.status': 'civili.systems · canal público oficial'
  },
  en: {
    documentTitle: 'CIVILI. The missing layer',
    documentDescription:
      'ATRIO answers WhatsApp with the real state of your system and hands a person anything that is not routine. CANTERA tells you who to write to, and why. CIVILI builds the layer your operation is missing.',
    'nav.skip': 'Skip to content',
    'nav.brand': 'CIVILI, back to the beginning',
    'nav.label': 'Main navigation',
    'nav.products': 'Products',
    'nav.layers': 'Custom build',
    'nav.method': 'Method',
    'nav.cta': 'Let’s talk',
    'nav.pause': 'Pause the motion',
    'nav.play': 'Resume the motion',

    'hero.title1': 'Your team',
    'hero.title2': 'should not be',
    'hero.title3': 'the integration layer.',
    'hero.kicker': 'One order. Four versions. None of them in charge.',
    'hero.primary': 'Show us where it breaks',
    'hero.secondary': 'See how it works',

    'ticker.i1': 'WhatsApp · order #742 · “about to go out” · 14:02',
    'ticker.i2': 'Spreadsheet · row 118 · dispatched · 11:30',
    'ticker.i3': 'ERP · SO-000742 · payment pending · 09:15',
    'ticker.i4': 'Memory · “Marta’s one” · still needed a check · yesterday',
    'ticker.alt':
      'Conceptual scene: the same order shows up in WhatsApp, a spreadsheet, the ERP and someone’s memory, holding a different state in each. It is not a client case.',

    'demo.example': 'Example',
    'demo.limitLabel': 'Where it stops',

    'atrio.label': 'Product 01 · Live',
    'atrio.name': 'ATRIO',
    'atrio.line': 'Answers what repeats. Hands you what does not.',
    'atrio.limit': 'It does not decide for you. When it stops being routine, it steps aside.',
    'atrio.channel': 'WhatsApp',
    'atrio.who1': 'Customer',
    'atrio.who2': 'ATRIO',
    'atrio.msg1': 'Has order 742 shipped yet?',
    'atrio.msg2': 'Yes, it left today at 11:30. Tracking TX-4471, arriving tomorrow.',
    'atrio.note2': 'read from your system, not from a script',
    'atrio.msg3': 'I have been waiting three days. This is a mess.',
    'atrio.handoff': 'A complaint. It does not reply: a person takes it.',
    'atrio.transcript':
      'Example conversation. The customer asks whether order 742 has shipped. ATRIO answers with the value read from the system: it left today at 11:30, tracking TX-4471, arriving tomorrow. The customer then writes that they have been waiting three days and this is a mess. ATRIO does not answer that message: it recognises a complaint and hands it to a person. It is not a client case.',

    'cantera.label': 'Product 02 · Built',
    'cantera.name': 'CANTERA',
    'cantera.line': 'Tells you who to write to, and why.',
    'cantera.limit': 'It does not buy lists or promise replies.',
    'cantera.target': 'Company · freight transport',
    'cantera.found': 'What it found on their site',
    'cantera.e1': 'WhatsApp button on every page',
    'cantera.e2': 'Three locations listed',
    'cantera.e3': 'Reviews answered by hand',
    'cantera.verdict': 'Qualifies',
    'cantera.reason': 'they run support over chat, by hand',
    'cantera.draftLabel': 'Draft',
    'cantera.draft': '“I saw you handle WhatsApp across all three locations…”',
    'cantera.gate': 'Nothing goes out until you approve it.',
    'cantera.transcript':
      'Example scene. CANTERA reads the public site of a freight transport company and notes what it finds: a WhatsApp button on every page, three locations listed, and reviews answered by hand. It qualifies the company on that basis and writes down the reason: they run support over chat, by hand. It drafts an email and stops there, because nothing goes out until a person approves it. It is not a client case.',

    'layers.label': 'Custom build',
    'layers.title': 'The rest gets built. Each layer states where it stops.',
    'layers.limit': 'The limit',
    'layers.l1name': 'One version of the truth',
    'layers.l1body': 'We connect what you use and settle which version is in charge.',
    'layers.l1limit': 'If two teams cannot agree on “ready”, no integration decides it for them.',
    'layers.l2name': 'Automate without losing control',
    'layers.l2body': 'It moves data and validates rules alone. Faced with the unusual, it stops.',
    'layers.l2limit': 'Automating a broken process only makes the error arrive faster.',
    'layers.l3name': 'The tool they actually use',
    'layers.l3body': 'The interface or CRM built on your real process.',
    'layers.l3limit': 'If a standard product solves it better, use it.',
    'layers.l4name': 'Knowledge that stays',
    'layers.l4body': 'What lives in chats and heads becomes written and searchable.',
    'layers.l4limit': 'If nobody ever wrote it down, no system remembers it for you.',

    'method.label': 'How we work',
    'method.title': 'No invoice until you approve what gets built.',
    'method.free': 'No cost',
    'method.paid': 'Paid',
    'method.p1title': 'Diagnosis',
    'method.p1body': 'Where state lives and what breaks it.',
    'method.p2title': 'Blueprint and MVP',
    'method.p2body': 'The real scope, and something you can try.',
    'method.p3title': 'Build',
    'method.p3body': 'If it takes more hours, the price holds.',
    'method.p4title': 'Transfer',
    'method.p4body': 'Your environment, your docs, your team.',
    'method.after': 'Maintenance and improvement are quoted separately. Recurring work comes from operating, not from locking you in.',

    'contact.title1': 'Tell us where',
    'contact.title2': 'the state gets lost.',
    'contact.terms': 'No cost · A business conversation · If building makes no sense, we say so',
    'contact.direct': 'Or write directly to',

    'form.review': 'Operational channel',
    'form.title': 'Prepare the conversation',
    'form.optional': 'optional',
    'form.role': 'Role',
    'form.phone': 'WhatsApp or phone',
    'form.phoneHint': 'Optional. It can speed up the first contact.',
    'form.team': 'People involved in this operation',
    'form.select': 'Select',
    'form.cost': 'What is costing the operation most today',
    'form.cost1': 'I do not know the underlying problem yet',
    'form.cost2': 'Systems hold conflicting versions',
    'form.cost3': 'Knowledge lives in a few people’s heads',
    'form.cost4': 'The pipeline is not observable',
    'form.cost5': 'Responding on time depends on who is available',
    'form.cost6': 'One task repeats far too often',
    'form.notice': 'Your request reaches CIVILI’s operational channel.',
    'form.name': 'Full name',
    'form.company': 'Company',
    'form.email': 'Work email',
    'form.context': 'Describe it in your own words',
    'form.contextHint': 'What happens today, who does it and how often. Two or three sentences are enough.',
    'form.consent': 'I authorize CIVILI to contact me about this request.',
    'form.submit': 'Send request',
    'form.submitting': 'Sending…',
    'form.cursorSend': 'Send',
    'form.invalid': 'Review the marked fields before continuing.',
    'form.success': 'Request received. We will keep this identifier as its reference.',
    'form.successTitle': 'The conversation has started.',
    'form.reset': 'Send another request',
    'form.networkError':
      'We could not send the request. Your answers are still here; try again or write to accounts@civili.systems.',
    'form.storageError':
      'The channel could not record the request. Your answers are still here; try again or write to accounts@civili.systems.',
    'form.rejectedError':
      'The request was not accepted. Review the information or write to accounts@civili.systems.',
    'form.privacy': 'We use this information only to contact you about this request.',
    'form.privacyLink': 'Privacy policy',
    'form.channelNote': 'It is used only to respond to this conversation.',

    'footer.position': 'We build how it should work.',
    'footer.evidence': 'CIVILI does not present simulations as client results.',
    'footer.company': 'CIVILI PROJECT SOLUTIONS S.A.S · Colombia',
    'footer.legal': 'Legal documents',
    'footer.privacy': 'Privacy policy',
    'footer.deletion': 'Data deletion',
    'footer.social': 'Social networks',
    'footer.status': 'civili.systems · official public channel'
  }
} as const;

export type SiteLanguage = keyof typeof content;
export type SiteDictionary = Readonly<Record<string, string>>;
